// OFCダッシュボードの画面に応じたAPIのパラメータを返す
export const getApiParam = (params: any) => {
  switch (params.mode) {
    case "dailyManagement":
      return {
        query:
          'query { dailyManagementSearchByParams(tenpoCode: "' +
          params.tenpoCode +
          '", yearMonth: "' +
          params.yearMonth +
          '") { tenpo_code date date_last_year tenpo_name do_code do_name zo_code zo_name ofc_code latitude longitude contract_type city_code day_of_week day_of_week_last_year is_holiday is_holiday_last_year sales_monthly_average_report sales_monthly_total_report sales_daily_report sales_monthly_average_last_year_report sales_monthly_total_last_year_report sales_daily_last_year_report sales_monthly_average_yoy_report sales_daily_yoy_report customer_count_monthly_average_report customer_count_monthly_total_report customer_count_daily_report customer_count_monthly_average_last_year_report customer_count_monthly_total_last_year_report customer_count_daily_last_year_report customer_count_monthly_average_yoy_report customer_count_daily_yoy_report waste_monthly_average_report waste_monthly_total_report waste_daily_report waste_monthly_average_last_year_report waste_monthly_total_last_year_report waste_daily_last_year_report waste_monthly_average_yoy_report waste_daily_yoy_report unit_price_monthly_average_report unit_price_monthly_total_report unit_price_daily_report unit_price_monthly_average_last_year_report unit_price_monthly_total_last_year_report unit_price_daily_last_year_report unit_price_monthly_average_yoy_report unit_price_daily_yoy_report quantity_monthly_average_report quantity_monthly_total_report quantity_daily_report quantity_monthly_average_last_year_report quantity_monthly_total_last_year_report quantity_daily_last_year_report quantity_monthly_average_yoy_report quantity_daily_yoy_report morning_sales_monthly_average morning_sales_monthly_total morning_sales_daily morning_sales_monthly_average_last_year morning_sales_monthly_total_last_year morning_sales_daily_last_year morning_sales_monthly_average_yoy morning_sales_daily_yoy daytime_sales_monthly_average daytime_sales_monthly_total daytime_sales_daily daytime_sales_monthly_average_last_year daytime_sales_monthly_total_last_year daytime_sales_daily_last_year daytime_sales_monthly_average_yoy daytime_sales_daily_yoy night_sales_monthly_average night_sales_monthly_total night_sales_daily night_sales_monthly_average_last_year night_sales_monthly_total_last_year night_sales_daily_last_year night_sales_monthly_average_yoy night_sales_daily_yoy allday_sales_monthly_average allday_sales_monthly_total allday_sales_daily allday_sales_monthly_average_last_year allday_sales_monthly_total_last_year allday_sales_daily_last_year allday_sales_monthly_average_yoy allday_sales_daily_yoy morning_customer_count_monthly_average morning_customer_count_monthly_total morning_customer_count_daily morning_customer_count_monthly_average_last_year morning_customer_count_monthly_total_last_year morning_customer_count_daily_last_year morning_customer_count_monthly_average_yoy morning_customer_count_daily_yoy daytime_customer_count_monthly_average daytime_customer_count_monthly_total daytime_customer_count_daily daytime_customer_count_monthly_average_last_year daytime_customer_count_monthly_total_last_year daytime_customer_count_daily_last_year daytime_customer_count_monthly_average_yoy daytime_customer_count_daily_yoy night_customer_count_monthly_average night_customer_count_monthly_total night_customer_count_daily night_customer_count_monthly_average_last_year night_customer_count_monthly_total_last_year night_customer_count_daily_last_year night_customer_count_monthly_average_yoy night_customer_count_daily_yoy allday_customer_count_monthly_average allday_customer_count_monthly_total allday_customer_count_daily allday_customer_count_monthly_average_last_year allday_customer_count_monthly_total_last_year allday_customer_count_daily_last_year allday_customer_count_monthly_average_yoy allday_customer_count_daily_yoy }}',
      };
    case "monthlyManagement":
      return {
        query:
          'query {  monthlyManagementSearchByParams(tenpoCode: "' +
          params.tenpoCode +
          '") {    tenpo_code year_month tenpo_name do_code do_name zo_code zo_name ofc_code latitude longitude contract_type city_code sales_monthly_average_report sales_monthly_average_yoy_report sales_monthly_average_last_year_report customer_count_monthly_average_report customer_count_monthly_average_yoy_report customer_count_monthly_average_last_year_report unit_price_monthly_average_report unit_price_monthly_average_yoy_report unit_price_monthly_average_last_year_report quantity_monthly_average_report quantity_monthly_average_yoy_report quantity_monthly_average_last_year_report morning_sales_monthly_average morning_sales_monthly_average_yoy morning_sales_monthly_average_last_year daytime_sales_monthly_average daytime_sales_monthly_average_yoy daytime_sales_monthly_average_last_year night_sales_monthly_average night_sales_monthly_average_yoy night_sales_monthly_average_last_year allday_sales_monthly_average allday_sales_monthly_average_yoy allday_sales_monthly_average_last_year morning_customer_count_monthly_average morning_customer_count_monthly_average_yoy morning_customer_count_monthly_average_last_year daytime_customer_count_monthly_average daytime_customer_count_monthly_average_yoy daytime_customer_count_monthly_average_last_year night_customer_count_monthly_average night_customer_count_monthly_average_yoy night_customer_count_monthly_average_last_year allday_customer_count_monthly_average allday_customer_count_monthly_average_yoy allday_customer_count_monthly_average_last_year allday_sales_monthly_total allday_sales_monthly_total_yoy allday_sales_monthly_total_last_year income_monthly_total income_monthly_total_yoy income_monthly_total_last_year salary_monthly_total salary_monthly_total_yoy salary_monthly_total_last_year inventory_diff_monthly_average inventory_diff_monthly_average_yoy inventory_diff_monthly_average_last_year inventory_price_diff_monthly_average inventory_price_diff_monthly_average_yoy inventory_price_diff_monthly_average_last_year defective_product_monthly_average defective_product_monthly_average_yoy defective_product_monthly_average_last_year defective_product_price_monthly_average defective_product_price_monthly_average_yoy defective_product_price_monthly_average_last_year operating_cost_monthly_total operating_cost_monthly_total_yoy operating_cost_monthly_total_last_year net_income_monthly_average net_income_product_monthly_average_yoy net_income_product_monthly_average_last_year open_account_monthly_average open_account_monthly_average_yoy open_account_monthly_average_last_year drawing_monthly_average drawing_monthly_average_yoy drawing_monthly_average_last_year tangible_net_worth_monthly_average tangible_net_worth_monthly_average_yoy tangible_net_worth_monthly_average_last_year gross_profit_monthly_total gross_profit_monthly_total_yoy gross_profit_monthly_total_last_year   }}',
      };
    case "getBigAreaData":
      return {
        query:
          'query {  getBigAreaData(doCode: "' +
          params.doCode +
          '", uuid: "' +
          params.uuid +
          '") {    parent_code code name latlng { lat lng } attribution{ direction_code direction_name sales }   }}',
      };
    case "getSmallAreaData":
      return {
        query:
          'query {  getSmallAreaData(big_area_uuid: "' +
          params.big_area_uuid +
          '", uuid: "' +
          params.uuid +
          '") {    parent_code code name latlng { lat lng } attribution{ polygon direction_code direction_name comment comment2 analysis_information cvs_data cvs_data_user_input sales }   }}',
      };
    case "getMajorFacilityData":
      return {
        query:
          'query {  getMajorFacilityData(big_area_uuid: "' +
          params.big_area_uuid +
          '") {    parent_code code name latlng { lat lng } attribution{ value unit comment }   }}',
      };
    case "existingSejStoreSearchByDistance":
      return {
        query:
          'query {  existingSejStoreSearchByDistance(longitude:' + params.longitude +
          ', latitude:' + params.latitude +
          ', distance:' + params.distance +
          ') {' +
            'store_code ' +
            'ctycode ' +
            'tenpo_name ' +
            'tenpo_address ' +
            'prop_site_no ' +
            'step ' +
            'centerlat ' +
            'centerlon ' +
            'geohash ' +
            'openingdate ' +
            'closingdate ' +
            'doname ' +
            'dmname ' +
            'ofcname ' +
            'zoname ' +
            'contract_type ' +
            'parkingarea ' +
            'sales_forecast ' +
            'salesfloor ' +
            'liquorlicense ' +
            'tobaccolicense ' + 
            'plan_area_feature ' +
            'building_feature ' + 
            'entrance_feature ' +
            'existing_best_location_flag ' +
            'store_direction ' +
            'sales_type ' +
            'existing_multi_flag ' +
          ' }}',
      };
    case "closedSejStoreSearchByDistance":
      return {
        query:
          'query {  closedSejStoreSearchByDistance(longitude:' + params.longitude +
          ', latitude:' + params.latitude +
          ', distance:' + params.distance +
          ') {' +
            'store_code ' +
            'ctycode ' +
            'tenpo_name ' +
            'tenpo_address ' +
            'prop_site_no ' +
            'step ' +
            'centerlat ' +
            'centerlon ' +
            'geohash ' +
            'openingdate ' +
            'closingdate ' +
            'dmname ' +
            'ofcname ' +
            'zoname ' +
            'contract_type ' +
            'customers ' +
            'parkingarea ' +
            'sales ' +
            'sales_forecast ' +
            'salesfloor ' +
            'liquorlicense ' +
            'tobaccolicense ' +
            'plan_area_feature ' +
            'building_feature ' +
            'entrance_feature ' +
            'update_date ' +
            'existing_best_location_flag ' +
            'existing_multi_flag ' +
            'store_direction' +
          ' }}',
      };
    case "planAreaSearchByDistance":
      return {
        query:
          'query {  planAreaSearchByDistance(longitude:' + params.longitude +
          ', latitude:' + params.latitude +
          ', distance:' + params.distance +
          ', manageCitiesFlg:' + params.manageCitiesFlg +
          ', manageCities:' + params.manageCities +
          ', manageStep:' + params.manageStep +
          ', managePlansOutsideCities:' + params.managePlansOutsideCities +
          ') {' +
            'id ' +
            'uuid ' +
            'centerlat ' +
            'centerlon ' +
            'entrance_feature ' +
            'plan_area_feature ' +
            'building_feature ' +
            'citycode ' +
            'display_flag ' +
            'deletable_flag ' +
            'request_flag ' +
            'edit_flag ' +
            'corporate_flag ' +
            'plan_area_name ' +
            'step ' +
            'plan_area_address ' +
            'plan_area_zipcode ' +
            'plan_area_townname ' +
            'plan_area_townname_serial_number ' +
            'zone_id ' +
            'plan_area_area_size ' +
            'building_area_size ' +
            'plan_area_current_state ' +
            'plan_area_owner_ids ' +
            'plan_area_amount_sales ' +
            'latlon_jpn ' +
            'do_code ' +
            'dm_confirm ' +
            'rm_confirm ' +
            'existing_best_location_flag ' +
            'existing_multi_flag ' +
            'evaluation_score ' +
            'evaluation_version ' +
            'visit_activity ' +
            'current_situation1 ' +
            'current_situation2 ' +
            'minor_classification1 ' +
            'minor_classification2 ' +
            'tenant_name1 ' +
            'tenant_name2 ' +
            'branch_name1 ' +
            'branch_name2 ' +
            'remarks ' +
            'pending_flag ' +
            'create_date ' +
            'update_date ' +
            'giving_up_reason ' +
            'store_direction ' +
            'zone_is_partial_step ' +
            'zone_plus_one_existing_feature ' +
            'zone_scrap_existing_feature ' +
            'zone_pincer_attack_flag ' +
          ' }}',
      };
    case "zoneSearchByDistance":
      return {
        query:
          'query {  zoneSearchByDistance(longitude:' + params.longitude +
          ', latitude:' + params.latitude +
          ', distance:' + params.distance +
          ', manageCitiesFlg:' + params.manageCitiesFlg +
          ', manageCities:' + params.manageCities +
          ') {' +
            'id ' +
            'uuid ' +
            'centerlat ' +
            'centerlon ' +
            // 'shape_geometry ' +
            'shape_feature ' +
            'citycode ' +
            'zone_name ' +
            'zone_type ' +
            'status ' +
            'request_flag ' +
            'zone_townname ' +
            'zone_townname_serial_number ' +
            'plan_area_id ' +
            'do_code ' +
            'dm_confirm ' +
            'rm_confirm ' +
            'intention ' +
            'plus_one_existing_store_name ' +
            'plus_one_existing_store_id ' +
            'plus_one_existing_feature ' +
            'plus_one_existing_latlng ' +
            'multi_owner_existing_store_name ' +
            'multi_owner_existing_store_id ' +
            'multi_owner_existing_feature ' +
            'multi_owner_existing_latlng ' +
            'scrap_existing_name ' +
            'scrap_existing_id ' +
            'scrap_existing_feature ' +
            'scrap_existing_latlng ' +
            'pincer_attack_flag ' +
            'pincer_attack_conflict_store_name ' +
            'pincer_attack_conflict_store_id ' +
            'pincer_attack_conflict_feature ' +
            'pincer_attack_conflict_latlng ' +
            'pincer_attack_existing_store_name ' +
            'pincer_attack_existing_store_id ' +
            'pincer_attack_existing_feature ' +
            'pincer_attack_existing_latlng ' +
            'is_partial_step ' +
            'create_date ' +
            'update_date ' +
          ' }}',
      };
    case "bigarea":
      return JSON.stringify(params.query);
    case "smallarea":
      return JSON.stringify(params.query);
    case "majorfacility":
      return JSON.stringify(params.query);
    case "strategypdf":
      return JSON.stringify(params.query);
    case "getConflictStores":
      return {
        query:
          'query {  getConflictStores(' +
          'longitude: ' + params.longitude +
          ', latitude: ' + params.latitude +
          ', distance: ' + params.distance +
          ', type: "' + params.type + '"' +
          ', hasClosed: "' + params.hasClosed + '"' +
          ') { ' +
          'id '+
          'uuid ' +
          'centerlat ' +
          'centerlon ' +
          'bland_id ' +
          'bland_name ' +
          'tenpo_name ' +
          'comment ' +
          'open_date ' +
          'close_date ' +
          'type ' +
          'handle_category_tobacco ' +
          'handle_category_liquor ' +
          '  }}',
      };
    default:
      return "";
  }
};
